import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { lessonsApi, universalApi } from "../api/api"

const useRooms = (query, triggerFetch, shouldSlice = true) => {
    const [data, setData] = useState([])

    const fetchData = async (q) => {
        const response = await simpleGetter(lessonsApi.roomsWithLessons, q || "")
        if ('list' in response) {
            setData(shouldSlice ? response.list.slice(0, 13) : response.list)
        }
    }

    useEffect(() => {
        fetchData(query)
    }, [query, triggerFetch])

    return data
}

const useRoom = (id) => {
    const [data, setData] = useState({})

    const fetchData = async () => {
        const reqBody = {
            model: 'Room',
            body: {
                filters: {
                    id
                }
            }
        }
        const response = await simpleGetter(universalApi.find, reqBody)
        if ('list' in response) {
            setData(response.list[0])
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return data
}

export {
    useRooms,
    useRoom
}